/* assets/frenly-collection-links.js (v2.70, 20 Oct 2026)
   Replaces the v2.66 collection page reload (sections/frenly-collection-defaults.liquid called
   location.replace to add sort_by and the In stock filter, so every shopper loaded each collection twice).
   Now the shop's own links to a collection already carry the same view, so the first load is the right one:
     (v2.84, 3 Nov 2026: sort_by=best-selling is no longer added; each collection opens in its own sort)
     filter.v.availability=1 (In stock), unless the shopper turned In stock off this visit (fbStockAll)
   A link that already names a sort keeps it, one that already sets In stock keeps it (same rules as the old reload).
   Search engines see clean links.
   Nothing reloads and store data is never changed.
   v2.73 (23 Oct 2026, Website growth leak 2): searches open in stock too. The header search, the quick search
   "see all" (both submit a form to /search) and the shop's own /search links get filter.v.availability=1, unless
   the shopper chose "Show sold out too" this visit (same fbStockAll flag). The search page shows that switch. */
(function () {
  'use strict';
  if (/bot|crawl|spider|slurp|google|bing|yandex|baidu|duckduck|facebookexternal|lighthouse|pagespeed|headless|petal|semrush|ahrefs|preview/i.test(navigator.userAgent || '')) return;
  var SKIP = ['new-arrivals', 'new-in', 'new-arrivals-lego', 'daily-deals', 'daily-sale', 'restocked', 'just-listed'];
  var RE = /^\/collections\/([a-z0-9-]+)\/?$/;
  var SEARCH = /^\/search\/?$/;
  function stockAll() { try { return sessionStorage.getItem('fbStockAll') === '1'; } catch (e) { return false; } }
  function fix(a) {
    if (!a || a.dataset.fbcl) return;
    a.dataset.fbcl = '1';
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
    if (u.origin !== location.origin) return;
    var q = u.searchParams;
    if (SEARCH.test(u.pathname)) {
      if (q.get('q') && !q.has('filter.v.availability') && !stockAll()) { q.set('filter.v.availability', '1'); a.setAttribute('href', u.pathname + '?' + q.toString() + u.hash); }
      return;
    }
    var m = RE.exec(u.pathname);
    if (!m) return;
    var h = m[1], changed = false;
    /* v2.84 (3 Nov 2026, lead 7): no sort_by added any more. It forced best selling over each collection's own
       sort (Game of Thrones manual order puts clean boxes first). Links that name a sort on purpose keep it. */
    if (!q.has('filter.v.availability') && !stockAll()) { q.set('filter.v.availability', '1'); changed = true; }
    if (changed) a.setAttribute('href', u.pathname + '?' + q.toString() + u.hash);
  }
  var SEL = 'a[href*="/collections/"], a[href*="/search?"]';
  function run(root) { var l = (root || document).querySelectorAll(SEL); for (var i = 0; i < l.length; i++) fix(l[i]); }
  run();
  // Cards and rails that render later (rails, menus, quick search) get the same links on first touch.
  document.addEventListener('pointerdown', function (e) { var a = e.target.closest && e.target.closest(SEL); if (a) fix(a); }, true);
  document.addEventListener('focusin', function (e) { var a = e.target.closest && e.target.closest(SEL); if (a) fix(a); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') { var a = document.activeElement; if (a && a.matches && a.matches(SEL)) fix(a); } }, true);
  // Search forms: add the In stock filter as the form is sent, so results open on things you can buy.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || stockAll()) return;
    var act;
    try { act = new URL(f.getAttribute('action') || location.href, location.href); } catch (x) { return; }
    if (act.origin !== location.origin || !SEARCH.test(act.pathname)) return;
    if (f.querySelector('[name="filter.v.availability"]')) return;
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'filter.v.availability'; i.value = '1';
    f.appendChild(i);
    if (!f.querySelector('[name="type"]')) { var t = document.createElement('input'); t.type = 'hidden'; t.name = 'type'; t.value = 'product'; f.appendChild(t); }
  }, true);
})();
